export default __webpack_public_path__ + "static/media/nutrionist@2x.08c03dc3.png";